import { render } from "./DepartmentDetails.vue?vue&type=template&id=1824c174&scoped=true"
import script from "./DepartmentDetails.vue?vue&type=script&lang=js"
export * from "./DepartmentDetails.vue?vue&type=script&lang=js"

import "./DepartmentDetails.vue?vue&type=style&index=0&id=1824c174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1824c174"]])

export default __exports__